module.exports = __webpack_public_path__ + "static/media/ic-alert.9ab1f20d.svg";